import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
import type { ReactNode } from 'react';
import { useCacheKey } from '@libs/common-next';
import css from './raw.module.scss';
interface Props {
  value: string;
  icon: ReactNode;
  onChange(value: string): void;
}
export function Raw(t0) {
  const $ = _c(21);
  const {
    value,
    icon,
    onChange
  } = t0;
  const {
    key
  } = useCacheKey();
  let t1;
  if ($[0] !== icon) {
    t1 = <span>{icon}</span>;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div><p className={css.title}>Raw cache key</p><p className={css.subtitle}>Base64 encoded cache key.</p></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = key !== value;
  let t4;
  if ($[3] !== t3) {
    t4 = cn(css.dot, {
      [css.modified]: t3
    });
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <span className={t4} />;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = key === value ? "Initial" : "Modified";
  let t7;
  if ($[7] !== t5 || $[8] !== t6) {
    t7 = <span className={css.chip}>{t5}{t6}</span>;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t1 || $[11] !== t7) {
    t8 = <header className={css.header}>{t1}{t2}{t7}</header>;
    $[10] = t1;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== onChange) {
    t9 = e => onChange(e.target.value);
    $[13] = onChange;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t9 || $[16] !== value) {
    t10 = <div className={css.key}><textarea value={value} name="cache-key" className={css.input} onChange={t9} autoComplete="off" /></div>;
    $[15] = t9;
    $[16] = value;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t8) {
    t11 = <section className={css.wrapper}>{t8}{t10}</section>;
    $[18] = t10;
    $[19] = t8;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
}